import {
  GET_SALON_DETAILS,
  DELETE_SERVICE,
  ADD_SALON_IMAGE,
  GET_ANALYTICS,
  ADD_LOGO_IMAGE,
  GET_SALON_USERS,
} from "../constants";

export const getSalonDetails = (payload) => ({
  type: GET_SALON_DETAILS,
  payload,
});

export const deleteSalonService = (payload) => ({
  type: DELETE_SERVICE,
  payload,
});

export const addSalonImage = (payload) => ({
  type: ADD_SALON_IMAGE,
  payload,
});

export const addLogoImage = (payload) => ({
  type: ADD_LOGO_IMAGE,
  payload,
});

export const getSalonAnalytics = (payload) => ({
  type: GET_ANALYTICS,
});

export const getSalonUsers = (payload) => ({
  type: GET_SALON_USERS,
  payload,
});
